import { render, staticRenderFns } from "./WorkspacePanel.vue?vue&type=template&id=5b94cf3b&scoped=true"
import script from "./WorkspacePanel.vue?vue&type=script&lang=js"
export * from "./WorkspacePanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspacePanel.vue?vue&type=style&index=0&id=5b94cf3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94cf3b",
  null
  
)

export default component.exports